<template>
  <el-dialog
    :title="'GIA HẠN PHÒNG'"
    :visible.sync="dialogExtendRoomVisible"
    width="90%"
    :close-on-click-modal="false"
    @close="
      () => {
        $emit('refresh')
      }
    "
  >
    <validation-observer ref="formValidator">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ 'Thông tin gia hạn phòng' }}
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="">
                <div class="label required">
                  {{ $t('field.checkInDate') }}
                </div>
                <div class="das-layout gap-10">
                  <div class="" style="flex: 1">
                    <SingleCalendar
                      v-model="formData.arrive_date"
                      :min-max="{ min: new Date() }"
                      :disabled="true"
                    />
                  </div>
                  <!-- <div class="l-w-33">
                    <TimePicker
                      v-model="formData.arrive_time"
                      format="HH:mm"
                      :disabled="true"
                    />
                  </div> -->
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="">
                <div class="label required">
                  {{ $t('field.checkOutDate') }}
                </div>
                <div class="das-layout gap-10">
                  <div class="" style="flex: 1">
                    <!-- <SingleCalendar
                      v-model="formData.depart_date"
                      style="display: block; width: 100%"
                      :min-max="{
                        min: new Date()
                      }"
                      mode="datetime"
                    /> -->
                    <CalendarSelect
                      v-model="formData.depart_date"
                      style="display: block; width: 100%"
                      mode="datetime"
                      :min-max="{
                        min: this.$moment().startOf('day').format('YYYY-MM-DD')
                      }"
                    />
                  </div>
                  <!-- <div class="l-w-33">
                    <TimePicker v-model="formData.depart_time" format="HH:mm" />
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="">
                <div class="label">
                  {{ $t('field.roomBooking') }}
                </div>
                <div class="input-group">
                  <input
                    :value="selectedRoom?.room_num"
                    type="text"
                    :disabled="roomSelectedDisabled"
                    @click="onOpenSelectRoomDialog"
                  />
                  <div class="input-group__append input-group-btn">
                    <button @click="onRemoveRoom">
                      <i class="el-icon-delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="das-form-col col-6">
              <div class="label">
                {{ 'Miễn phí/Nội bộ' }}
              </div>
              <el-select v-model="formData.price_type" clearable>
                <el-option :value="1" label="Miễn phí"></el-option>
                <el-option :value="2" label="Nội bộ"></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <hr />

        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ 'Giá phòng' }}
          </div>
        </div>

        <BookingRoomDailyPriceTable
          ref="BookingRoomDailyPriceTable"
          :record-rows="formData.daily_prices"
          @updateRow="onUpdateDailyPriceRow"
        ></BookingRoomDailyPriceTable></div
    ></validation-observer>

    <BookingRoomSelectRoomDialog
      v-if="isSelectRoomDialogOpened"
      :selected-data="{
        roomNumber: null,
        hotelId: data.hotel_id,
        roomLevelId: data.room_level_id,
        arriveDate: formData.arrive_date,
        departDate: formData.depart_date,
        depart_time: formData.depart_time,
        arrive_time: formData.arrive_time
      }"
      :hotels="hotelOptions"
      @close="isSelectRoomDialogOpened = false"
      @roomSelected="onRoomSelected"
    ></BookingRoomSelectRoomDialog>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogExtendRoomVisible = false"
        >
          {{ 'Đóng' }}
        </button>
        <button class="btn primary small" @click="onExtendRoom">
          {{ 'Gia hạn phòng' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
// import { getRoomListApi } from '@/api/booking_service/bookingGroup'
// import { generateDailyPriceApi } from '@/api/booking_service/booking'
// import { getBookingGroupAvailableRoomLevelListApi } from '@/api/booking_service/bookingGroupApi'
// import { getHotelListApi } from '@/api/booking_service/bookingGroup'
// import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import BookingRoomSelectRoomDialog from '@/components/resources/booking/BookingRoomSelectRoomDialog.vue'
import BookingRoomDailyPriceTable from '@/components/resources/booking/BookingRoomDailyPriceTable.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'

import { getAllHotels } from '@/api/configuration/hotel/hotel'
import { extendRoomBooking } from '@/api/reception/reception'
// import { notifyError } from '@/utils/toast'
import { generateDailyPriceApi } from '@/api/booking_service/booking'
import { updateCardPeriod } from '@/api/reception/card_service'

export default {
  components: {
    BookingRoomSelectRoomDialog,
    BookingRoomDailyPriceTable,
    CalendarSelect
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      isHydrated: false,
      // arriveDate: null,
      // arrivalTime: '14:00',
      // departDate: null,
      // departTime: '12:00',
      formData: {
        booking_group_id: null,
        sub_booking_group_id: null,
        arrive_date: this.$moment().format('YYYY-MM-DD'),
        depart_date: this.$moment()
          .add(1, 'days')
          .startOf('day')
          .add(12, 'hour')
          .format('YYYY-MM-DD HH:mm'),
        arrive_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        },
        room_id: null,
        room_level_id: null,
        price_type: null,
        daily_prices: []
      },
      defaultFormData: {
        booking_group_id: null,
        sub_booking_group_id: null,
        arrive_date: this.$moment().format('YYYY-MM-DD'),
        depart_date: this.$moment()
          .add(1, 'days')
          .startOf('day')
          .add(12, 'hour')
          .format('YYYY-MM-DD HH:mm'),
        arrive_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        },
        room_id: null,
        room_level_id: null,
        price_type: null,
        daily_prices: []
      },

      selectedRoom: {},

      // dialog
      roomSelectedDisabled: false,
      isSelectRoomDialogOpened: false,
      hotelOptions: []
    }
  },
  computed: {
    dialogExtendRoomVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.selectedBooking = { ...this.data }
        this.$emit('input', val)
      }
    }
  },

  watch: {
    data(nv, ov) {
      if (nv) {
        const departDate = this.$moment(
          this.data?.depart_date,
          'DD-MM-YYYY HH:mm:ss'
        )
        this.formData.arrive_date = departDate.format('YYYY-MM-DD')
        this.formData.arrive_time = {
          // HH: departDate.format('HH'),
          // mm: departDate.format('mm')
          HH: '14',
          mm: '00'
        }
        if (departDate.isBefore(this.$moment())) {
          this.formData.depart_date = this.$moment()
            .add(1, 'days')
            .startOf('day')
            .add(12, 'hour')
            .format('YYYY-MM-DD HH:mm')
        } else {
          this.formData.depart_date = departDate
            .add(1, 'days')
            .startOf('day')
            .add(12, 'hour')
            .format('YYYY-MM-DD HH:mm')
        }
        this.formData.room_level_id = nv?.room_level_id
        this.formData.room_id = nv?.room_id
        this.selectedRoom.room_id = nv?.room_id
        this.selectedRoom.room_num = nv?.room_num
        this.formData.sub_booking_group_id = +nv?.sub_booking_group_id
        this.formData.booking_group_id = nv?.booking_id

        this.onChangeBookingDate()
      }
    },

    'formData.depart_date'(nv, ov) {
      // console.log(nv, ov)
      if (nv) {
        this.roomSelectedDisabled = false
        this.onChangeBookingDate()
      } else {
        this.roomSelectedDisabled = true
      }
    }
  },

  async mounted() {
    this.isHydrated = false
    await Promise.all([this.getHotelOptions()])
    this.isHydrated = true
  },

  methods: {
    onRemoveRoom() {
      this.formData.room_id = null
      this.selectedRoom = null
    },
    onOpenSelectRoomDialog() {
      this.isSelectRoomDialogOpened = true
    },

    onUpdateDailyPriceRow(colName, params, value) {
      // console.log('onUpdateDailyPriceRow', params, value, colName)
      const rowIndex = params.rowIndex
      const fieldName = params.colDef.field
      this.formData.daily_prices[rowIndex][fieldName] = value
      if (fieldName === 'percent_discount') {
        this.formData.daily_prices[rowIndex]['amount_discount'] = null
      } else if (fieldName === 'amount_discount') {
        this.formData.daily_prices[rowIndex]['percent_discount'] = null
      }
      // this.$refs.BookingRoomDailyPriceTable.$refs.agGrid.gridOptions.api.refreshCells(
      //   {
      //     force: true
      //   }
      // )
    },

    // handle api call
    async getDailyPrice() {
      if (this.formData.room_level_id == null) {
        return
      }

      if (
        this.$moment(this.formData.depart_date).format('YYYY-MM-DD') ===
        this.formData.arrive_date
      ) {
        this.formData.daily_prices = []
        this.$message({
          type: 'success',
          message: 'Đã cập nhật chi tiết giá ngày.'
        })
        return
      }

      return generateDailyPriceApi(
        this.formData.arrive_date,
        this.formData.depart_date,
        this.formData.room_level_id,
        false
      )
        .then(res => {
          this.formData.daily_prices = res.data.map(day => {
            return {
              id: 0,
              price: day.price,
              date: day.date,
              note: null,
              price_code_id: day.price_code_id,
              price_code: day.price_code,
              nett: day.nett,
              currency_id: day.currency_id,
              currency_code: day.currency_code,
              exchange_rate: day.exchange_rate,
              percent_discount: day.percent_discount,
              amount_discount: day.amount_discount,
              discount_reason: day.discount_reason
            }
          })
          this.$message({
            type: 'success',
            message: 'Đã cập nhật chi tiết giá ngày.'
          })
        })
        .catch(err => {
          throw err
        })
    },
    async onChangeBookingDate() {
      if (!this.isHydrated) {
        return
      }
      // await this.getRoomTypeOptions(
      //   `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
      //   `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      // )
      await this.getDailyPrice()
      // if (
      //   this.roomLevelOptions.findIndex(
      //     level => level.room_type_id == this.formData.room_type_id
      //   ) === -1
      // ) {
      //   this.formData.daily_price = []
      //   this.formData.room_type_id = null
      //   this.formData.room_id = null
      //   this.selectedRoom = null
      // }
    },
    async onRoomSelected(room) {
      if (!this.isHydrated) {
        return
      }
      // TODO: Check this with backend for consistent type for ID
      const room_level_id = parseInt(room.room_level_id)
      // const isRoomLevelChanged = this.formData.room_level_id !== room_level_id
      this.formData.room_id = room.room_id
      this.hotel_id = room.hotel_id
      this.selectedRoom = room
      this.isSelectRoomDialogOpened = false

      // if (isRoomLevelChanged) {
      this.formData.room_level_id = room_level_id
      await this.getDailyPrice()
      // }
    },
    async getHotelOptions() {
      await getAllHotels().then(response => {
        this.hotelOptions = response.data
      })
    },

    async onExtendRoom() {
      const arriveDate = `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`
      const departDate = `${this.formData.depart_date}`
      this.formData.room_id = this.selectedRoom?.room_id
      const data = {
        // booking_group_id: this.formData.booking_group_id,
        sub_booking_group_id: this.formData.sub_booking_group_id,
        arrive_date: arriveDate,
        depart_date: departDate,
        room_id: this.formData.room_id,
        room_level_id: this.formData.room_level_id,
        price_type: this.formData.price_type,
        daily_prices: this.formData.daily_prices
      }
      // console.log(data)

      try {
        await extendRoomBooking(data).then(data => {
          if (!data.is_error) {
            this.$message({
              message: this.$t(`successMsg.${data?.message}`),
              type: 'success'
            })
          } else {
            // throw new Error(data)
            this.$message({
              message: this.$t(`errorMsg.${data?.message}`),
              type: 'error'
            })
          }
        })
        await updateCardPeriod({
          roomId: this.formData.room_id,
          startDate: `${arriveDate}:00`,
          endDate: `${departDate}:00`
        })
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      }

      this.dialogExtendRoomVisible = false
    }
  }
}
</script>

<style>
.button-containers {
  margin: 0 !important;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

<style lang="scss" scoped>
::v-deep {
  .dateTimeMode {
    width: 100% !important;
  }
}
</style>
